import x from './HuntHorsesSecond';

export default x;
